import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageHeaderComponent } from '@shared/ui/components';
import { KatalogSkupinSablonFilterFormService } from '../../services/katalog-skupin-sablon-filter-form.service';
import { KatalogSkupinSablonOverviewFilterComponent } from './katalog-skupin-sablon-overview-filter/katalog-skupin-sablon-overview-filter.component';

@Component({
  selector: 'reza-katalog-skupin-sablon-main',
  templateUrl: './main.component.html',
  imports: [PageHeaderComponent, KatalogSkupinSablonOverviewFilterComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [KatalogSkupinSablonFilterFormService],
})
export class KatalogSkupinSablonMainPageComponent {}
